<template>
  <div id="monitoramento">
    <div class="row">
      <div class="col-md-12">
        <vuestic-widget headerText="Monitoramento das Aulas Virtuais">
          <div class="text-center">
            <h1 id="clock"></h1>
          </div>
          <div class="row text-center">
            <div
              class="col-sm-6"
              v-for="(sala, id) in salasFiltradas"
              :key="id"
            >
              <div class="card" v-if="sala.aula.alunos">
                <div class="row">
                  <div
                    class="col-sm-6"
                    v-for="i in 2"
                    :key="i"
                    style="padding-rigth:0; margin-rigth:0; "
                  >
                    <img
                      v-if="sala.aula.alunos[i - 1]"
                      class="avatar"
                      width="250px"
                      height="250px"
                      :src="'data:image/' + sala.aula.alunos[i - 1].fotos[sala.aula.alunos[i - 1].fotos.length - 1].ext +';base64, ' + sala.aula.alunos[i - 1].fotos[sala.aula.alunos[i - 1].fotos.length - 1].foto"
                      alt="Imagem 1"
                      :id="sala.aula.alunos[0].fotos[0].id_foto_teorica + '_' + i"
                    />
                    <br><br>
                  </div>
                </div>
                <div class="container">
                  <h2>
                    <b>{{ sala.sala }}</b>
                  </h2>
                  <div class="row">
                    <div class="col-md-12">
                      <button class="btn btn-primary btn-sm" @click="paginaSala(sala)"> Versão minimizada </button>
                       &nbsp;
                      <button class="btn btn-primary btn-sm"  @click="paginaSalaMaximizada(sala)"> Versão maximizada </button>
                    </div>
                  </div>
                  <br>
                  <div class="row" style="justify-content: center;">
                    <table class="table-responsive-sm" v-if="sala.aula.aula">
                      <tr>
                        <td>CFC:</td>
                        <td>{{ sala.cfc }}</td>
                      </tr>
                      <tr>
                        <td>Turma:</td>
                        <td>{{ sala.aula.aula.turma.titulo }}</td>
                      </tr>
                      <tr>
                        <td>Aula:</td>
                        <td>{{ sala.aula.aula.id_aula_teorica }}</td>
                      </tr>
                      <tr>
                        <td>Instrutor:</td>
                        <td>{{ sala.aula.aula.instrutor.nome }}</td>
                      </tr>
                      <tr>
                        <td>Materia:</td>
                        <td>{{ sala.aula.aula.materia.titulo }}</td>
                      </tr>
                      <tr>
                        <td>Aula iniciada as:</td>
                        <td>{{ sala.aula.aula.inicio.split(' ')[1] }}</td>
                      </tr>
                      <tr>
                        <td>Fim previsto:</td>
                        <td>{{ sala.aula.aula.fim.split(' ')[1] }}</td>
                      </tr>
                      <tr>
                        <td>Quantidade de alunos na turma:</td>
                        <td>{{ sala.aula.aula.turma.quantidade_alunos }}</td>
                      </tr>
                      <tr>
                        <td>Presenças confirmadas:</td>
                        <td>{{ sala.aula.aula.quantidade_alunos_presentes }}</td>
                      </tr>
                    </table>
                  </div>
                  <br />
                  <br />
                </div>
              </div>
            </div>
          </div>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>
<script>
import MonitoramentoController from './MonitoramentoController'

export default {
  data () {
    return {
      quantidade: 2,
      salas: [],
      imageCheck: false,
      aulas: [],
      salaModal: [],
      salaModalCheck: false,
      imageModal: 'image-check',
      count_faces: 0,
    }
  },
  mounted () {
    let self = this
    MonitoramentoController.startTime()

    MonitoramentoController.getSalasVirtuais(function (data) {
      data.dados.map(function (value) {
        self.salas.push({
          id: value.id_sala,
          sala: value.sala,
          cfc: value.cfc,
          aula: [],
        })
      })

      self.showAula()
    })
  },
  computed: {
    salasFiltradas: function () {
      return this.salas.filter(function (sala) {
        if (sala.aula.length !== 0) {
          return sala
        }
      })
    },
  },
  methods: {
    showAula () {
      let self = this

      self.salas.forEach((sala, index) => {
        MonitoramentoController.getAulaTeorica(function (aula) {
          if (aula != null) {
            self.salas[index].aula = aula
          }
        }, sala)
      })
    },
    paginaSala (sala) {
      MonitoramentoController.paginaSala(sala)
    },
    paginaSalaMaximizada (sala) {
      MonitoramentoController.paginaSalaMaximizada(sala)
    }
  },
}
</script scoped>

<style scoped>
.pointer {
  cursor: pointer;
}
.centralizado {
  text-align: center;
}
.avatar {
  position: relative;
}

.teste:hover {
  top: -2px;
  box-shadow: 0 2px 2px #666;
}

.aula {
  border: rgb(134, 129, 129) solid 2px;
  border-radius: 2%;
}
/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgb(24, 255, 3);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 10px; /* 5px rounded corners */
  margin: 5px;
}

/* Add rounded corners to the top left and the top right corner of the image */
.img-monit {
  width: 450px;
  border-radius: 10px 10px 0 0;
}

.img-monit-modal {
  width: 500px;
  height: 500px;
  border-radius: 10px;
}

.img-thumb {
  width: 200px;
  height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

#clock {
  font-family: "Share Tech Mono", monospace;
  color: #080808;
  text-align: center;
}

.size {
  width: 4rem;
  height: 4rem;
}

tr {
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.13);
}

table {
  width: 100%;
}
</style>
